import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckMark = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.79508 15.875L4.62508 11.705L3.20508 13.115L8.79508 18.705L20.7951 6.70498L19.3851 5.29498L8.79508 15.875Z",
		fill: "current"
	})
});
export default SvgCheckMark;
